<template>
	<section>
		<!--工具条-->
		<div :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker type="month" v-model="filters.date"   style="width: 100%;"></el-date-picker>
                </el-form-item>
				<el-form-item>
					<create-form-button      @select-type="bornForm" ></create-form-button>
					<download-form-button    @select-type="clickBtn" ></download-form-button>
				</el-form-item>
			</el-form>
		</div>

		<div id="formCon"  v-loading="loading"   element-loading-text="报表生成中"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0, 0, 0, 0.8)">
			<div id="title">
				<div class="title1"><span>{{projectName}}环境噪声状况分析报告</span></div>
				<div class="title2">
					<span class="span2"> {{date2}}</span>
				</div>
				<div class="title3"><span>{{date2}}噪声月报</span></div>
				<div class="condes"><span>目前我市功能区声环境自动监测站共{{totalStr}}个{{deviceInfoStr}}。</span></div>
			</div>
			<div id="con1">
				<div class="contitle">一、本月总体运行情况</div>
				<div class="contitle">1.设备运行情况</div>
				<p class="condes" v-if="totalData.statusStr==''">{{date1}}各站点监测设备整体运行正常。</p>
				<p class="condes"  v-else>{{date1}}各站点监测设备运行情况：{{totalData.statusStr}}。其他监测设备运行正常。</p>
				<div class="contentAdd2"><span>{{alarmInfoStr}}</span></div>
				<div class="contitle">2.软件运行情况</div>
				<p class="condes">{{date1}}各平台运行状况良好，未进行功能调整或修复。</p>
			</div>
			<div id="con2">
				<div class="contitle">二、全区噪声情况</div>
				<div class="contitle">1.噪声概况</div>

				<p class="condes">
					<span>计算各点位{{date1}}的数据均值，</span
					><span>{{totalData.allStr}}。</span
					><span v-if="totalData.rateStr!=''">环比上月，{{totalData.rateStr}}。</span>
				</p>
				<div id="con2add"></div>
			</div>
			<div id="con3">
				<div class="contitle">2.噪声变化趋势（日均值折线图）</div>
				<div id="chart1" class="chartDiv1"></div>
				<div id="chart1img"></div>

				<div id="calimg" style="width:70%;margin:0 auto;text-align:center"  ></div>
			</div>
			<div id="con4">
				<div class="contitle">3.各点位值和环比情况</div>
				<div id="con4add"></div>
			</div>
			<div id="con5">
				<div class="contitle">4.各点位均值值排名情况</div>
				<div id="con5add"></div>
			</div>
			<div id="con6">
				<div class="contitle">5.各功能区达标率统计情况</div>
				<div id="con6add"></div>
				<div id="chart6" class="chartDiv1"></div>
				<div id="chart6img"></div>
			</div>
			<div id="con7">
				<div class="contitle">6.各子项目平均值</div>
				<div id="con7add"></div>
			</div>
		</div>

	</section>
</template>

<script>
	import * as echarts from "echarts";
	import {getProjects,bornMonthForm } from '../../api/api';
	import {formatDate4,formatDateForm2,formatDate3,in_array} from '../../../static/fun.js';
	import {handleWindowPrint,drawEchartImg,initContent,deleteImg} from '../../../static/print.js';
	import html2Canvas from 'html2canvas'
	import CreateFormButton from '../../components/myButton/CreateFormButton.vue'
	import DownloadFormButton from '../../components/myButton/DownloadFormButton.vue'

	export default {
	components: { DownloadFormButton,CreateFormButton },
		data() {
			return {
				filters: {
					projectId: '',
					date:''
				},
				projects:[],
				projectName:'',

				totalData:{
					allStr:'',
					statusStr:'',
					rateStr:'',
				},
				facList:[],
				facDic:[],
				date1:'',
				date2:'',
				picArr:[],
				loading:false,
				BiType:1,
				chooseNames:[],
				today:'本月',
				yesterday:'上月',
				orderNum:3,

				childVisible:false,//是否含有子项目
				totalStr:'',
				deviceInfoStr:'',
				alarmInfoStr:''

			}
			
		},
		methods: {
			clickBtn(type){
				if(type=="pdf"){
					this.exportPDF();
				}else if(type=="word"){
					this.exportWord();
				}
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					
					this.projects = res.data.data;
					this.listLoading = false;
					if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.projectName=this.projects[0].name;
					}
				});
			},
			bornForm(){
				this.loading=true;
				this.getProjectName();
				this.getDate();
				var param={
					projectId:this.filters.projectId,
					date:formatDate3(this.filters.date),
					type:"month"
				}
				bornMonthForm(param).then((res) => {
					this.loading=false;
					if(res.data.code!=200){
						this.$message({
							message: "查询失败，请重试",
							type: 'error'
						})
						return;
					}

					var resData=res.data.data;
					this.facList=resData.facList;
					this.facDic=resData.facDic;

					var proLen=Object.keys(resData.dicMonth).length;
					if(proLen>1){
						this.childVisible=true;
					}
					var con7= document.getElementById('con7');
					if(!this.childVisible) {
						con7.style.display="none";
					};

					this.totalStr=Object.keys(resData.devices).length;

					//部分数据赋值
					this.assignValue(resData);
					//渲染均值折线图
					this.initAvgChart(resData);
					//渲染环比情况
					this.initCirData(resData);
					//渲染排名情况
					this.initOrderData(resData);
					//渲染噪声概况
					this.initTotalData(resData);
					//渲染达标率统计情况
					this.initRateData(resData);
				});
			},
			initTotalData(resData){
				var functionareaList=resData.functionalAreas;
				var funMap=new Map();
				var strname="";
				var strday="";
				var strnight="";
				for(var j=0;j<functionareaList.length;j++){
					var obj=functionareaList[j];
					var funid=obj.id;
					funMap.set(funid,obj);

					strname+='<td>'+obj.name+'</td>';
					strday+='<td>'+obj.day+'</td>';
					strnight+='<td>'+obj.night+'</td>';
				}

				//先删除上次生成标签
				var body = document.getElementById('con2add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";
				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
							+'<thead>'
								+'<tr>'
									+'<td rowspan="2"  width="40px">序号</td>'
									+'<td rowspan="2">功能区</td>'
									+'<td rowspan="2" >点位名称</td>';
				var nameStr="";
				var unitStr="";
				var fac="";
				
				this.facList.forEach(element => {
					var name=JSON.parse(sessionStorage.getItem(element)).name;
					var lgd='('+JSON.parse(sessionStorage.getItem(element)).unit+')';
					
					if(element=="n00004"){
						nameStr+='<td colspan="5">昼间监测数据（dB）</td>';

						unitStr+='<td style="font-size:10px">月均值Ld</td>';
						unitStr+='<td style="font-size:10px">最大值Ldmax</td>';
						unitStr+='<td style="font-size:10px">日均值超标天数</td>';
						unitStr+='<td style="font-size:10px">本月有效监测天数</td>';
						unitStr+='<td style="font-size:10px">达标率</td>';

					}else if(element=="n00005"){
						nameStr+='<td colspan="5">夜间监测数据（dB）</td>';

						unitStr+='<td style="font-size:10px">月均值Ln</td>';
						unitStr+='<td style="font-size:10px">最大值Lnmax</td>';
						unitStr+='<td style="font-size:10px">日均值超标天数</td>';
						unitStr+='<td style="font-size:10px">本月有效监测天数</td>';
						unitStr+='<td style="font-size:10px">达标率</td>';
					}else{
						nameStr+='<td style="font-size:10px">'+name+'</td>';
						if(lgd!="()"){
							unitStr+='<td style="font-size:10px">'+lgd+'</td>';
						}else{
							unitStr+='<td style="font-size:10px"></td>';
						}
					}
					fac=element;
				})
				str+=nameStr+'</tr>';
				str+='<tr style="font-size:10px">'+unitStr+'</tr></thead>';
				//head结束，整理数据
				var objArr=[];
				var objMap=new Map();//记录mn下标值
				var i=0;
				this.facDic[fac].orderDataList.forEach(ele => {
					var objOne={};
					objOne.index=i+1;
					var mn=ele.mn;
					var funid=resData.devices[mn].functionalAreaId;
					//显示名字
					var obj=funMap.get(funid);

					objOne.funName=obj.name;
					objOne.devName=ele.name;
					objOne.mn=mn;
					objArr.push(objOne);
					objMap.set(mn,i);
					i++;
				});

				var i=0;
				this.facDic[fac].orderDataList.forEach(ele => {
					var objOne={};
					var j=0;//第一个因子
					this.facList.forEach(element => {
						//获取对象所在的数据
						var value=this.facDic[element].orderDataList[i].today;
						var mn=this.facDic[element].orderDataList[i].mn;
						var index=objMap.get(mn);
						objOne=objArr[index];
						if(value==null){
							value="";
						}
						var strfun=false;
						if(element=="n00004"||element=="n00005"){
							if(value!=""){
								//先取mn
								var mn=this.facDic[element].orderDataList[i].mn;
								var funid=resData.devices[mn].functionalAreaId;
								//取限值
								var obj=funMap.get(funid);
								//昼
								if(element=="n00004"&&value>obj.day){
									strfun=true;
								}
								//夜
								if(element=="n00005"&&value>obj.night){
									strfun=true;
								}
							}
						}
						if(strfun==false){
							objOne[element+"color"]="";
						}else{
							objOne[element+"color"]="red";
						}
						objOne[element+"value"]=value;
						if(element=="n00004"||element=="n00005"){
							var valueRate=this.facDic[element].orderDataList[i].validrate;

							var max=this.facDic[element].orderDataList[i].max;
							var count=this.facDic[element].orderDataList[i].count;
							var validcount=this.facDic[element].orderDataList[i].validcount;
							if(max==null){
								max="";
							}
							if(count==null){
								count="";
							}
							if(validcount==null||count==""){
								validcount="";
							}else{
								validcount=count-validcount;
							}
							if(valueRate==null){
								valueRate="";
							}
							objOne[element+"max"]=max;
							objOne[element+"validcount"]=validcount;
							objOne[element+"count"]=count;
							objOne[element+"valueRate"]=valueRate;
						}
						objArr[index]=objOne;
						j++;
					});
					
					i++;
				});
				//开始添加内容
				str+='<tbody>';
				var i=0;
				objArr.forEach(ele => {
					str+='<tr>';
					str+='<td>'+ele.index+'</td>';
					str+='<td>'+ele.funName+'</td>';
					str+='<td >'+ele.devName+'</td>';

					this.facList.forEach(element => {
						
						if(ele[element+"color"]==""){
							str+='<td>'+ele[element+"value"]+'</td>';
						}else{
							str+='<td class="red">'+ele[element+"value"]+'</td>';
						}
						if(element=="n00004"||element=="n00005"){
							
							str+='<td>'+ele[element+"max"]+'</td>';
							str+='<td>'+ele[element+"validcount"]+'</td>';
							str+='<td>'+ele[element+"count"]+'</td>';
							str+='<td>'+ele[element+"valueRate"]+'</td>';
						}
					});
					str+='</tr>';
					i++;
				});
				str+='<tr><td rowspan="3"  colspan="4">噪声限值</td>'+
					'<td  colspan="4">功能区</td>'+strname+'</tr>';
				str+='<tr><td  colspan="4">Ld限值（dB）</td>'+strday+'</tr>';
				str+='<tr><td  colspan="4">Ln限值（dB）</td>'+strnight+'</tr>';
				str+='</tbody></table>';
				div.innerHTML=str;
				body.appendChild(div);
			},
			initCirData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con4add');
				body.innerHTML='';
				this.facList.forEach(element => {
					if(element=="primarypollutant"||element=="aqi"){
					}else{
						var name=JSON.parse(sessionStorage.getItem(element)).name;
						var lgd=name+'('+JSON.parse(sessionStorage.getItem(element)).unit+')';
						var div = document.createElement('div');
						div.className="con3div";
						var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
							+'<thead>'
								+'<tr>'
									+'<td rowspan="2">序号</td>'
									+'<td rowspan="2">点位名称</td>'
									+'<td rowspan="2">功能区名称</td>'
									+'<td colspan="2">限值(dB)</td>'
									+'<td colspan="3">'+lgd+'</td>'
								+'</tr>'
								+'<tr>'
									+'<td>昼间</td>'
									+'<td>夜间</td>'
									+'<td>'+this.today+'</td>'
									+'<td>'+this.yesterday+'</td>'
									+'<td>环比率</td>'
								+'</tr>'
							+'</thead>'
							+'<tbody>';
							var i=1;
							var dataList=this.facDic[element].orderDataList;
							dataList.forEach(ele => {
								var mnInfo=resData.devices[ele.mn];
								str+='<tr>'
									+'<td>'+i+'</td>'
									+'<td style="text-align:left">'+ele.name+'</td>'
									+'<td>'+mnInfo.functionalArea.name+'</td>'
									+'<td>'+mnInfo.functionalArea.day+'</td>'
									+'<td>'+mnInfo.functionalArea.night+'</td>'
									+'<td>'+(ele.today==null?'':ele.today)+'</td>'
									+'<td>'+(ele.yesterday==null?'':ele.yesterday)+'</td>'
									+'<td>'+(ele.rate==null?'':ele.rate)+'</td>'
									+'</tr>';
								i++;
							});
							str+='</tbody>';
						str+='</table>';
						str+='<p class="condes">'+this.date1+'，'+name+' 最低的是'+dataList[i-2].name+'，'+name+'最高的是'+dataList[0].name+'。</p>';
						div.innerHTML=str;
						body.appendChild(div);
					}
				})

				this.initChartdetail(resData);
			},
			initRateData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con6add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";

				var aData=[];
				var seriesData=[
					{
						type:'bar',
						name:'昼间',
						color:'#4DA2F7',
						data:[]
					},
					{
						type:'bar',
						name:'夜间',
						color:'#ED8A46',
						data:[]
					}
				];


				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
					+'<thead>'
						+'<tr>'
							+'<td rowspan="2">序号</td>'
							+'<td rowspan="2">功能区类型</td>'
							+'<td rowspan="2">个数</td>'
							+'<td colspan="2">昼间</td>'
							+'<td colspan="2">夜间</td>'
						+'</tr>'
						+'<tr>'
							+'<td>dB</td>'
							+'<td>%</td>'
							+'<td>dB</td>'
							+'<td>%</td>'
						+'</tr>'
					+'</thead>'
					+'<tbody>';
					var i=1;
					var dataList=resData.complianceRate;
					dataList.forEach(ele => {
						str+='<tr>'
							+'<td>'+i+'</td>'
							+'<td >'+ele.functionalAreaName+'</td>'
							+'<td>'+ele.count+'</td>'
							+'<td>'+ele.dayData+'</td>'
							+'<td>'+ele.dayRate+'</td>'
							+'<td>'+ele.nightData+'</td>'
							+'<td>'+ele.nightRate+'</td>'
							+'</tr>';
						i++;

						aData.push(ele.functionalAreaName);
						seriesData[0].data.push(ele.dayRate);
						seriesData[1].data.push(ele.nightRate);
					});
					str+='</tbody>';
				str+='</table>';
				div.innerHTML=str;
				body.appendChild(div);
			
				this.drawRateDataChart(aData,seriesData);  
				this.picArr.push("chart6");
			},
			drawRateDataChart:function(aData,seriesData) {
                this.chartLine = echarts.init(document.getElementById('chart6'));
                this.chartLine.setOption({
                      tooltip: {
                        trigger: 'axis',
                        formatter: function(params) {
                            var result = params[0].name+'<br>';
                            params.forEach(function(item) {
                                result +=item.seriesName+" : "+'<span style="display:inline-block;min-width:80px">'+ item.data+"%</span><br>"
                            });
                            return result;
                        },
                    },
                    legend: {
                        data: ["昼间","夜间"],
                        itemWidth: 10,  // 设置宽度
                        itemHeight: 10, // 设置高度
                    },
                    grid: {
                        left: '3%',
                        right: '6%',
                        bottom: '4%',
                        top:60,
                        containLabel: true
                    },
                    xAxis: {
                        name:'功能区类别',
                        data:aData
                    },
                    yAxis: {
                        type: 'value',
                        name:'达标率(%)',
                    },
                    series:seriesData
                 },true);
            },
			initOrderData(res){
				//先删除上次生成标签
				var body = document.getElementById('con5add');
				body.innerHTML='';
				this.facList.forEach(element => {
					if(element=="primarypollutant"||element=="aqi"){
					}else{
						var name=JSON.parse(sessionStorage.getItem(element)).name;
						var unit='('+JSON.parse(sessionStorage.getItem(element)).unit+')';
						var div = document.createElement('div');
						div.className="con3div";
						var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
							+'<thead>'
								+'<tr>'
									+'<td rowspan="2">排名</td>'
									+'<td rowspan="2">点位名称</td>'
									+'<td >'+name+'</td>'
								+'</tr>'
								+'<tr>'
									+'<td>'+unit+'</td>'
								+'</tr>'
							+'</thead>'
							+'<tbody>';
							var i=1;
							var dataList=this.facDic[element].orderDataList;
							dataList.forEach(ele => {
								str+='<tr>'
									+'<td>'+i+'</td>'
									+'<td style="text-align:left">'+ele.name+'</td>'
									+'<td>'+(ele.today==null?'':ele.today)+'</td>'
									+'</tr>';
								i++;
							});
							str+='</tbody>';
						str+='</table>';
							var minAndMax="";
							for(var i=0;i<this.orderNum;i++){
								minAndMax+=dataList[i].name;
								if(i!=this.orderNum-1){
									minAndMax+=",";
								}
							}
						str+='<p class="condes">'+this.date1+'，'+name+' 值最高的子站前'+this.orderNum+'名点位是：'+minAndMax+'。</p>';
						div.innerHTML=str;
						body.appendChild(div);
					}
				})
			},
			initChildData(res,aData,factor){
				if(!this.childVisible) {
					return;
				};
				var con7= document.getElementById('con7');
				con7.style.display="block";

				//先删除上次生成标签
				var body = document.getElementById('con7add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";
				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
							+'<thead>'
								+'<tr>'
									+'<td rowspan="2"  width="40px">序号</td>'
									+'<td rowspan="2">子项目名称</td>';
				var nameStr="";
				var unitStr="";
				var fac="";
				this.facList.forEach(element => {
					if(element=="primarypollutant"){
					}else{
						var name=JSON.parse(sessionStorage.getItem(element)).name;
						var lgd='('+JSON.parse(sessionStorage.getItem(element)).unit+')';
						nameStr+='<td style="font-size:10px">'+name+'</td>';
						if(lgd!="()"){
							unitStr+='<td style="font-size:10px">'+lgd+'</td>';
						}else{
							unitStr+='<td style="font-size:10px"></td>';
						}
						fac=element;
					}
				})
				str+=nameStr+'</tr>';
				str+='<tr style="font-size:10px">'+unitStr+'</tr></thead>';
				//head结束，开始添加内容
				str+='<tbody>';

				var i=0;
				for (var j in res.dicMonth) {//子项目
					str+='<tr>';
					str+='<td>'+(i+1)+'</td>';
					str+='<td>'+j+'</td>';
					this.facList.forEach(element => {
						if(element=="primarypollutant"){
						}else{
							var value=res.dicMonth[j][element].today;
							if(value==null){
								value="";
							}
							str+='<td>'+value+'</td>';
						}
					});
					str+='</tr>';
					i++;
				}
				str+='</tbody></table>';
				div.innerHTML=str;
				body.appendChild(div);
				this.initChildChartData(res,aData,factor);
			},
			initChildChartData(resData,aData,factor){
				var i=0;
				var seriesDataAll=[];
				//打印
				let prostr=resData.dicMonth;
				var i=0;
				for (var j in prostr) {//mn
					let deviceOne={};
					deviceOne.type='line';
					deviceOne.name=j;
					deviceOne.connectNulls=false;//null中断
					deviceOne.data=[];
					deviceOne.smooth=true;//光滑连接
					seriesDataAll.push(deviceOne);
					i++;
					this.chooseNames.push(j);
				}

				var i=122;
				var k=0;
				//每一个因子
				this.facList.forEach(fac => {
					var factor=JSON.parse(sessionStorage.getItem(fac)).name;
					var  seriesData= JSON.parse(JSON.stringify(seriesDataAll));
					for (let index = 0; index < seriesData.length; index++) {
						const element = seriesData[index];
						var data=resData.dicMonth[element.name];
						element.data=data[fac].avgList;
					}

					//先删除上次生成标签
					var body = document.getElementById('con7add');
					var div = document.createElement('div');
					div.id="chart"+i;
					div.className="chartDiv2 con3div";
					var body = document.getElementById('con7add');
					body.appendChild(div);
					this.drawLineChart(aData,seriesData,"chart"+i,this.chooseNames,factor+'趋势图'); 
					var div2 = document.createElement('div');
					div2.id="chart"+i+"img";
					div2.className="con3div";
					body.appendChild(div2);
					this.picArr.push("chart"+i);
					i++;
				})
			} ,
			initAvgChart(resData){
				this.picArr=[];
				let aData=resData.timeList;
				var seriesData=[];
				var legendData=[];
				this.facList.forEach(element => {
					if(element=="aqi"||element=="primarypollutant"){
					}else{
						let facArr=this.facDic[element].avgList;
						var lgd=JSON.parse(sessionStorage.getItem(element)).name+'('+JSON.parse(sessionStorage.getItem(element)).unit+')';
						var obj={
							name: lgd,
							type: 'line',
							data: facArr
						};
						seriesData.push(obj);
						legendData.push(lgd);
					}
				});
				this.drawLineChart(aData,seriesData,'chart1',legendData,'数据变化趋势图');  
				this.picArr.push("chart1");
			},
			initChartdetail(resData){
				//数据格式处理	
				let aData=resData.timeList;
				let mnstr=resData.devices;
				var i=0;
				this.chooseNames=[];
				var seriesDataAll=[];
				var mnAndFunMap=new Map();//funid  mn
				for (var j in mnstr) {//mn
					let deviceOne={};
					deviceOne.type='line';
					deviceOne.name=mnstr[j].name;
					deviceOne.nameTep=j;
					deviceOne.connectNulls=false;//null中断
					deviceOne.data=[];
					deviceOne.smooth=true;//光滑连接
					seriesDataAll.push(deviceOne);
					i++;
					this.chooseNames.push(mnstr[j].name);

					var funid=mnstr[j].functionalAreaId;
					var arr=[];
					if(mnAndFunMap.get(funid)==undefined||mnAndFunMap.get(funid)==null){
						arr=[j];
						mnAndFunMap.set(funid,arr);
					}else{
						arr=mnAndFunMap.get(funid);
						arr.push(j);
						mnAndFunMap.set(funid,arr);
					}
				}
				
				var i=2;
				var facarr=[];
				var functionareaList=resData.functionalAreas;
				this.facList.forEach(fac => {
					var factor=JSON.parse(sessionStorage.getItem(fac)).name;
					if(fac=="primarypollutant"){
					}else{
						//对功能区循环 取出对应的折线图数据
						for(var j=0;j<functionareaList.length;j++){
							var seriesDataFun=[];
							var mnName=[];
							var funidTep=functionareaList[j].id;
							var funName=functionareaList[j].name;
							var arr=mnAndFunMap.get(funidTep);
							if(arr==undefined||arr==null){//没有设备

							}else{//取设备数据
								//获取数据
								var  seriesData= JSON.parse(JSON.stringify(seriesDataAll));

								for (let index = 0; index < seriesData.length; index++) {
									const element = seriesData[index];

									if( in_array(element.nameTep,arr)){//包含在此功能区中
										mnName.push(mnstr[element.nameTep].name)
										var data=resData.dataList[element.nameTep];
										for (let j = 0; j < data.length; j++) {
											const dataOne = data[j];
											element.data.push(dataOne[fac])
										}
										seriesDataFun.push(element);
									}
								}
								//对其中一个功能区取数完毕
								if(seriesDataFun.length>0){
									var div = document.createElement('div');
									div.id="chart"+i+funidTep;
									div.className="chartDiv2 con3div";
									var body = document.getElementById('con4add');
									body.appendChild(div);
									this.drawLineChart(aData,seriesDataFun,"chart"+i+funidTep,mnName,funName+"_"+factor+'趋势图'); 
									var div2 = document.createElement('div');
									div2.id="chart"+i+funidTep+"img";
									div2.className="con3div";
									body.appendChild(div2);
									this.picArr.push("chart"+i+funidTep);
								}
							}
						}
						facarr.push(factor);
						i++;
					}
				})

				this.initChildData(resData,aData,facarr);
			},
			assignValue(resData){
				this.deviceInfoStr=resData.project.forminfo;
				this.totalData.statusStr=resData.statusStr;
				this.orderNum=Math.min(Object.keys(resData.devices).length,5);
				this.totalData.allStr="";
				this.totalData.rateStr="";
				this.facList.forEach(element => {
					if(element=="primarypollutant"){
					}else if(element=="aqi"){
					}else{
						var fac=JSON.parse(sessionStorage.getItem(element));
						this.totalData.allStr+=fac.name+"值为"+this.facDic[element].today+fac.unit+",";
						var rate=this.getType(this.facDic[element].rate);
						if(rate!=""){
							this.totalData.rateStr+=fac.name+rate+",";					
						}			
					}
				});
				if(this.totalData.allStr!=""){
					this.totalData.allStr=this.totalData.allStr.substring(0,this.totalData.allStr.length-1);
				}
				if(this.totalData.rateStr!=""){
					this.totalData.rateStr=this.totalData.rateStr.substring(0,this.totalData.rateStr.length-1);
				}
			},
			getType(rate){
				if(rate==null){
					return "";
				} else if(rate.indexOf("-")==-1){
					return "上升"+rate;
				}else if(rate=="0%"){
					return "持平";
				}else{
					return "下降"+rate.split('-')[1];
				}
			},
			drawLineChart:function(aData,seriesData,id,legendData,title) {
				var tit = ['','',''];
				var lgdStyle={
					data: legendTep,
					top:40,
					itemWidth: 10,  // 设置宽度
					itemHeight: 10, // 设置高度
					x:'right'
				};
				var topH=parseInt(seriesData.length/4)*20+60;
				if(topH>200){
					topH=80;
					lgdStyle={
						type: 'scroll', //分页类型
						data: legendTep,
						top:40,
						itemWidth: 10,  // 设置宽度
						itemHeight: 10, // 设置高度
						x:'right'
					};
				}
                var legendTep = tit.concat(legendData);
               	var chart = echarts.init(document.getElementById(id));
                chart.setOption({
					backgroundColor: '#fff',
                    title: {
                        text: title,
                        x:'left'
                    },
                    toolbox: {
                        show : true
                    },
                    legend: lgdStyle,
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top:topH,
                        containLabel: true
                    },
                    xAxis: {
                        boundaryGap: true,
						data:aData,
						"axisLabel":{
							interval: 0,
							rotate: 60,
                            margin:5,
						}
                    },
                    yAxis: {
						type: 'value',
						scale: true
                    },
                    series:seriesData
            	},true);
            },
			exportPDF(){
				var flag=handleWindowPrint('#formCon',this.picArr);
				if(!flag){
					this.$message({
						message: "导出报表出错，请重试",
						type: 'error'
					})
				}
			},
			exportWord(){
				if(drawEchartImg(this.picArr)){
					var content=initContent('#formCon');
					var converted = htmlDocx.asBlob(content);
					saveAs(converted, this.projectName+"_"+this.date1+'.docx');
					deleteImg(this.picArr);

					return;
				}
			},
			getProjectName(){
				 this.projects.forEach(item => {
					if(this.filters.projectId==item.projectId){
						this.projectName=item.name;
						return;
					}
				});
			},
			getDate(){
				var date = new Date(this.filters.date);
				this.date1= date.getMonth()+1+'月份';
				this.date2=formatDateForm2(this.filters.date);
			},
		},
		mounted() {
			this.getProjects();
			//time设为上个月
			var date = new Date();
			this.filters.date=date.getTime() - 3600 * 1000 * 24 * (date.getDate());
			this.getDate();
		}
	}

</script>
<style>
	@import 'form.css';
</style>


// WEBPACK FOOTER //
// month.vue?e78ca3fa